import { cn } from '@/platform/lib/utils';
import Header from '../Header';

// `as` sets the heading level: h2 by default, h1 for the first title on a page.
const SegmentHeader = ({
    as = 'h2',
    header,
    subheader,
    className,
    children,
    ...props
}) => (
    <div
        className={cn(
            'flex items-start justify-between gap-4 px-6 pt-8 pb-2',
            className
        )}
        {...props}
    >
        <div className='min-w-0 flex-1'>
            {header && <Header as={as}>{header}</Header>}
            {subheader && (
                <p className='mt-1 text-sm text-gray-500'>{subheader}</p>
            )}
        </div>
        {children && (
            <div className='flex shrink-0 items-center gap-2'>{children}</div>
        )}
    </div>
);

export default SegmentHeader;
